// extracted by mini-css-extract-plugin
export default {"fields":"GeofenceForm_fields__9Zzdt"};